import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import OurStory from '../components/OurStory';
import SafeFun from '../components/SafeFun';
import JoinNow from '../components/JoinNow';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <HowItWorks />
      <OurStory />
      <SafeFun />
      <JoinNow />
      <Footer />
    </div>
  );
};

export default Home;
